// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"5862":"580b9c2e231a9169a12f","6798":"995524658ab188a2d123","7471":"b4ac70873a3ab192efd0"}[chunkId] + "";
};